import React from 'react';
import Contact, { CustomerContactAtFinn } from './contact';

export type AppProps = {
    customerContactAtFinn?: CustomerContactAtFinn;
};

export default function App({
    customerContactAtFinn,
}: AppProps = {}): React.ReactElement {
    return <Contact customerContactAtFinn={customerContactAtFinn} />;
}
